/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const labOrders = sqliteTable('lab_orders', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  visit_id: text('visit_id'),
  encounter_id: text('encounter_id'),
  appointment_id: text('appointment_id'),
  queue_id: text('queue_id'),
  ordering_provider_id: text('ordering_provider_id'),
  ordered_by: text('ordered_by'),
  ordered_by_name: text('ordered_by_name'),
  source: text('source'),
  order_number: text('order_number'),
  notes: text('notes'),
  ordered_at: text('ordered_at'),
  cancelled_at: text('cancelled_at'),
  cancelled_by: text('cancelled_by'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
